/* eslint-disable max-len */

import { CSSProperties, FC, ReactNode, useState } from 'react';
import { Button, ButtonProps, Tooltip } from 'antd';
import { CloudDownloadOutlined } from '@ant-design/icons';
import apiRequests from 'utils/api';
import apiRoutes from 'config/apiRoute';
import asyncErrorHandler from 'utils/asyncErrorHandler';

interface DownloadFileButtonProps {
  uuid: string;
  name?: string;
  icon?: ReactNode;
  size?: ButtonProps['size'];
  style?: CSSProperties;
  hideTooltip?: boolean;
  className?: string;
}

const DownloadFileButton: FC<DownloadFileButtonProps> = ({ uuid, name, icon, size, style, hideTooltip = false, className = '' }) => {
  const [downloading, setDownloading] = useState(false);

  const onClickHandler = () => {
    setDownloading(true);

    apiRequests
      .get(`${apiRoutes.UPLOADS}/${uuid}/download`)
      .then((response) => {
        const link = document.createElement('a');
        link.href = response.data;
        if (name) {
          link.download = name;
        }
        link.click();
      })
      .catch((error) => {
        asyncErrorHandler(error);
      })
      .finally(() => {
        setDownloading(false);
      });
  };

  return (
    <Tooltip title="Download" {...(hideTooltip ? { visible: false } : {})} className={className}>
      <Button
        type="link"
        size={size}
        onClick={onClickHandler}
        icon={icon ?? <CloudDownloadOutlined />}
        loading={downloading}
        style={style}
      />
    </Tooltip>
  );
};

export default DownloadFileButton;
